/* The Marine Emporium — theme behaviour
   Small, dependency-free enhancements. Everything degrades to plain form posts. */

(function () {
  'use strict';

  var cfg = window.MarineTheme || {};
  var routes = cfg.routes || {};

  /* ---------------------------------------------------------------- helpers */

  function on(root, event, selector, handler) {
    root.addEventListener(event, function (e) {
      var target = e.target.closest(selector);
      if (target && root.contains(target)) handler(e, target);
    });
  }

  function formatMoney(cents) {
    var format = cfg.moneyFormat || '£{{amount}}';
    var value = (cents / 100).toFixed(2);
    var parts = value.split('.');
    var withCommas = parts[0].replace(/\B(?=(\d{3})+(?!\d))/g, ',');

    return format
      .replace(/\{\{\s*amount\s*\}\}/, withCommas + '.' + parts[1])
      .replace(/\{\{\s*amount_no_decimals\s*\}\}/, withCommas)
      .replace(/\{\{\s*amount_with_comma_separator\s*\}\}/, parts[0].replace(/\B(?=(\d{3})+(?!\d))/g, '.') + ',' + parts[1])
      .replace(/\{\{\s*amount_no_decimals_with_comma_separator\s*\}\}/, parts[0].replace(/\B(?=(\d{3})+(?!\d))/g, '.'));
  }

  /* ------------------------------------------------------------- mobile nav */

  var navToggle = document.querySelector('[data-nav-toggle]');
  var nav = document.querySelector('[data-nav]');
  var navClose = document.querySelector('[data-nav-close]');

  function setNav(open) {
    if (!nav) return;
    nav.dataset.open = open ? 'true' : 'false';
    if (navToggle) navToggle.setAttribute('aria-expanded', open ? 'true' : 'false');
    document.documentElement.style.overflow = open ? 'hidden' : '';
    if (open) {
      var first = nav.querySelector('a, button');
      if (first) first.focus();
    }
  }

  if (navToggle) navToggle.addEventListener('click', function () { setNav(nav.dataset.open !== 'true'); });
  if (navClose) navClose.addEventListener('click', function () { setNav(false); navToggle && navToggle.focus(); });

  document.addEventListener('keydown', function (e) {
    if (e.key === 'Escape' && nav && nav.dataset.open === 'true') {
      setNav(false);
      navToggle && navToggle.focus();
    }
  });

  /* ------------------------------------------------------------ quantity +/- */

  on(document, 'click', '[data-quantity-button]', function (e, button) {
    e.preventDefault();
    var wrapper = button.closest('.quantity');
    if (!wrapper) return;
    var input = wrapper.querySelector('input');
    if (!input) return;

    var step = button.dataset.quantityButton === 'plus' ? 1 : -1;
    var min = parseInt(input.min, 10);
    if (isNaN(min)) min = 0;
    var next = (parseInt(input.value, 10) || 0) + step;
    if (next < min) next = min;

    input.value = next;
    input.dispatchEvent(new Event('change', { bubbles: true }));
  });

  /* --------------------------------------------------------- variant picker */

  document.querySelectorAll('[data-variant-picker]').forEach(function (picker) {
    var form = picker.closest('form') || document.querySelector('[data-product-form="' + picker.dataset.variantPicker + '"]');
    var dataEl = document.getElementById(picker.dataset.variantData);
    if (!dataEl) return;

    var variants;
    try {
      variants = JSON.parse(dataEl.textContent);
    } catch (err) {
      return;
    }

    var section = picker.closest('[data-product-root]') || document;

    function selectedOptions() {
      return Array.prototype.map.call(
        picker.querySelectorAll('input[type="radio"]:checked, select'),
        function (el) { return el.value; }
      );
    }

    function matchVariant(options) {
      return variants.find(function (variant) {
        return variant.options.every(function (value, index) { return value === options[index]; });
      });
    }

    function updateAvailability(options) {
      // Grey out option values that cannot combine with the current selection.
      picker.querySelectorAll('[data-option-position]').forEach(function (group) {
        var position = parseInt(group.dataset.optionPosition, 10) - 1;

        group.querySelectorAll('input[type="radio"]').forEach(function (input) {
          var candidate = options.slice();
          candidate[position] = input.value;

          var reachable = variants.some(function (variant) {
            if (!variant.available) return false;
            return variant.options.every(function (value, index) {
              return index === position ? value === input.value : value === candidate[index];
            });
          });

          input.disabled = !reachable && !input.checked;
        });
      });
    }

    function update() {
      var options = selectedOptions();
      var variant = matchVariant(options);

      updateAvailability(options);

      var idInput = section.querySelector('[data-variant-id]');
      var submit = section.querySelector('[data-add-to-cart]');
      var priceTarget = section.querySelector('[data-price-target]');
      var skuTarget = section.querySelector('[data-sku-target]');

      if (!variant) {
        if (submit) {
          submit.disabled = true;
          submit.textContent = 'Unavailable';
        }
        return;
      }

      if (idInput) idInput.value = variant.id;

      if (submit) {
        submit.disabled = !variant.available;
        submit.textContent = variant.available ? submit.dataset.addLabel || 'Add to bag' : 'Sold out';
      }

      if (priceTarget) {
        var html = '<span class="price__current">' + formatMoney(variant.price) + '</span>';
        if (variant.compare_at_price && variant.compare_at_price > variant.price) {
          html += '<s class="price__compare">' + formatMoney(variant.compare_at_price) + '</s>';
        }
        priceTarget.innerHTML = html;
        priceTarget.classList.toggle(
          'price--on-sale',
          !!(variant.compare_at_price && variant.compare_at_price > variant.price)
        );
      }

      if (skuTarget) skuTarget.textContent = variant.sku || '';

      // Bring the matching image into view if the variant has one.
      if (variant.featured_media_id) {
        var thumb = section.querySelector('[data-media-id="' + variant.featured_media_id + '"]');
        if (thumb) thumb.click();
      }

      if (history.replaceState) {
        var url = new URL(window.location.href);
        url.searchParams.set('variant', variant.id);
        history.replaceState({}, '', url.toString());
      }
    }

    picker.addEventListener('change', update);
    update();
  });

  /* ------------------------------------------------------------ product media */

  on(document, 'click', '[data-media-id]', function (e, thumb) {
    e.preventDefault();
    var root = thumb.closest('[data-product-root]') || document;
    var main = root.querySelector('[data-media-main]');
    if (!main) return;

    var img = thumb.querySelector('img');
    if (!img) return;

    var target = main.querySelector('img');
    if (target) {
      target.src = img.dataset.full || img.src;
      target.srcset = img.dataset.fullSrcset || '';
      target.alt = img.alt;
    }

    root.querySelectorAll('[data-media-id]').forEach(function (t) {
      t.setAttribute('aria-current', t === thumb ? 'true' : 'false');
    });
  });

  /* --------------------------------------------------------------- cart toast */

  var toast = document.getElementById('CartToast');
  var toastTimer;

  function showToast(message) {
    if (!toast) return;
    var text = toast.querySelector('.cart-toast__text');
    if (text && message) text.textContent = message;
    toast.hidden = false;
    requestAnimationFrame(function () { toast.dataset.visible = 'true'; });
    clearTimeout(toastTimer);
    toastTimer = setTimeout(function () {
      toast.dataset.visible = 'false';
      setTimeout(function () { toast.hidden = true; }, 300);
    }, 4000);
  }

  function refreshCartCount() {
    return fetch(routes.cart_url + '.js', { headers: { Accept: 'application/json' } })
      .then(function (r) { return r.json(); })
      .then(function (cart) {
        document.querySelectorAll('[data-cart-count]').forEach(function (el) {
          el.textContent = cart.item_count;
        });
        return cart;
      })
      .catch(function () { /* count stays as-is */ });
  }

  /* ------------------------------------------------------------- ajax add-to-cart */

  if (cfg.ajaxCart) {
    on(document, 'submit', 'form[data-product-form]', function (e, form) {
      e.preventDefault();

      var submit = form.querySelector('[data-add-to-cart]');
      var original = submit ? submit.textContent : '';
      if (submit) {
        submit.disabled = true;
        submit.textContent = 'Adding…';
      }

      var errorTarget = form.querySelector('[data-form-error]');
      if (errorTarget) errorTarget.hidden = true;

      fetch(routes.cart_add_url + '.js', {
        method: 'POST',
        headers: { Accept: 'application/json' },
        body: new FormData(form)
      })
        .then(function (response) {
          return response.json().then(function (body) {
            return { ok: response.ok, body: body };
          });
        })
        .then(function (result) {
          if (!result.ok) {
            var message = result.body.description || result.body.message || 'Sorry, that could not be added.';
            if (errorTarget) {
              errorTarget.textContent = message;
              errorTarget.hidden = false;
            } else {
              showToast(message);
            }
            return;
          }

          showToast('Added to your bag');
          return refreshCartCount();
        })
        .catch(function () {
          form.submit(); // fall back to a normal post
        })
        .finally(function () {
          if (submit) {
            submit.disabled = false;
            submit.textContent = original;
          }
        });
    });
  }

  /* ------------------------------------------------------------- cart line edits */

  var cartRoot = document.querySelector('[data-cart-root]');

  if (cartRoot) {
    var pending;

    function updateLine(key, quantity) {
      clearTimeout(pending);
      cartRoot.setAttribute('aria-busy', 'true');

      return fetch(routes.cart_change_url + '.js', {
        method: 'POST',
        headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
        body: JSON.stringify({ id: key, quantity: quantity, sections: 'main-cart' })
      })
        .then(function (r) { return r.json(); })
        .then(function (cart) {
          if (cart.sections && cart.sections['main-cart']) {
            var parsed = new DOMParser().parseFromString(cart.sections['main-cart'], 'text/html');
            var fresh = parsed.querySelector('[data-cart-root]');
            if (fresh) cartRoot.innerHTML = fresh.innerHTML;
          } else {
            window.location.reload();
          }
          return refreshCartCount();
        })
        .catch(function () { window.location.reload(); })
        .finally(function () { cartRoot.removeAttribute('aria-busy'); });
    }

    on(cartRoot, 'change', '[data-cart-quantity]', function (e, input) {
      var quantity = parseInt(input.value, 10);
      if (isNaN(quantity) || quantity < 0) return;
      clearTimeout(pending);
      pending = setTimeout(function () { updateLine(input.dataset.cartQuantity, quantity); }, 250);
    });

    on(cartRoot, 'click', '[data-cart-remove]', function (e, button) {
      e.preventDefault();
      updateLine(button.dataset.cartRemove, 0);
    });
  }

  /* --------------------------------------------------- collection sort submit */

  on(document, 'change', '[data-auto-submit]', function (e, select) {
    var form = select.closest('form');
    if (form) form.submit();
  });

  /* --------------------------------------------------------------- facets */

  var facetForm = document.getElementById('FacetForm');
  var facetPanel = document.querySelector('[data-facets-panel]');
  var facetScrim = document.querySelector('.collection-facets__scrim');
  var facetOpen = document.querySelector('[data-facets-open]');
  var facetDebounce;

  function setFacets(open) {
    if (!facetPanel) return;
    facetPanel.dataset.open = open ? 'true' : 'false';
    if (facetScrim) facetScrim.hidden = !open;
    if (facetOpen) facetOpen.setAttribute('aria-expanded', open ? 'true' : 'false');
    document.documentElement.style.overflow = open ? 'hidden' : '';
  }

  if (facetOpen) facetOpen.addEventListener('click', function () { setFacets(true); });

  document.querySelectorAll('[data-facets-close]').forEach(function (el) {
    el.addEventListener('click', function () {
      setFacets(false);
      if (facetOpen) facetOpen.focus();
    });
  });

  document.addEventListener('keydown', function (e) {
    if (e.key === 'Escape' && facetPanel && facetPanel.dataset.open === 'true') setFacets(false);
  });

  if (facetForm) {
    // Any filter change re-runs the query. Text inputs are debounced.
    facetForm.addEventListener('change', function (e) {
      if (!e.target.matches('[data-facet-input]')) return;
      var delay = e.target.type === 'number' ? 600 : 0;
      clearTimeout(facetDebounce);
      facetDebounce = setTimeout(submitFacets, delay);
    });

    // The sort select lives outside the form but is associated via form="FacetForm".
    document.querySelectorAll('select[form="FacetForm"]').forEach(function (select) {
      select.addEventListener('change', submitFacets);
    });

    facetForm.addEventListener('submit', function (e) {
      e.preventDefault();
      submitFacets();
    });
  }

  /* ------------------------------------------------------------- lightbox */

  var lightbox = document.getElementById('Lightbox');

  if (lightbox) {
    var lbImage = lightbox.querySelector('.lightbox__image');
    var lbCaption = lightbox.querySelector('.lightbox__caption');
    var lbCounter = lightbox.querySelector('.lightbox__counter');
    var lbGroup = [];
    var lbIndex = 0;
    var lbTrigger = null;

    function openLightbox(img) {
      // The group is every lightbox image inside the same section, so arrow
      // keys walk through one gallery rather than the whole page.
      var scope = img.closest('.shopify-section') || document;
      lbGroup = Array.prototype.slice.call(scope.querySelectorAll('[data-lightbox]'));
      lbIndex = lbGroup.indexOf(img);
      lbTrigger = img;

      render();
      lightbox.dataset.open = 'true';
      document.documentElement.style.overflow = 'hidden';
      lightbox.querySelector('.lightbox__close').focus();
    }

    function closeLightbox() {
      lightbox.dataset.open = 'false';
      document.documentElement.style.overflow = '';
      if (lbTrigger) lbTrigger.focus();
    }

    function step(delta) {
      if (lbGroup.length < 2) return;
      lbIndex = (lbIndex + delta + lbGroup.length) % lbGroup.length;
      render();
    }

    function render() {
      var img = lbGroup[lbIndex];
      if (!img) return;

      lbImage.src = img.dataset.lightboxFull || img.src;
      lbImage.alt = img.alt || '';

      var caption = img.dataset.lightboxCaption || '';
      lbCaption.textContent = caption;
      lbCaption.hidden = !caption;

      if (lbGroup.length > 1) {
        lbCounter.textContent = lbIndex + 1 + ' / ' + lbGroup.length;
        lbCounter.hidden = false;
      } else {
        lbCounter.hidden = true;
      }

      var multiple = lbGroup.length > 1;
      lightbox.querySelector('.lightbox__prev').hidden = !multiple;
      lightbox.querySelector('.lightbox__next').hidden = !multiple;
    }

    on(document, 'click', '[data-lightbox]', function (e, img) {
      e.preventDefault();
      openLightbox(img);
    });

    on(document, 'keydown', '[data-lightbox]', function (e, img) {
      if (e.key === 'Enter' || e.key === ' ') {
        e.preventDefault();
        openLightbox(img);
      }
    });

    lightbox.querySelector('.lightbox__close').addEventListener('click', closeLightbox);
    lightbox.querySelector('.lightbox__prev').addEventListener('click', function () { step(-1); });
    lightbox.querySelector('.lightbox__next').addEventListener('click', function () { step(1); });

    lightbox.addEventListener('click', function (e) {
      if (e.target === lightbox) closeLightbox();
    });

    document.addEventListener('keydown', function (e) {
      if (lightbox.dataset.open !== 'true') return;
      if (e.key === 'Escape') closeLightbox();
      if (e.key === 'ArrowLeft') step(-1);
      if (e.key === 'ArrowRight') step(1);
    });
  }

  function submitFacets() {
    if (!facetForm) return;

    var params = new URLSearchParams();

    // Include the associated sort select, which lives outside the form element.
    document.querySelectorAll('select[form="FacetForm"]').forEach(function (select) {
      if (select.value) params.append(select.name, select.value);
    });

    new FormData(facetForm).forEach(function (value, key) {
      if (value === '' || value == null) return;
      if (key === 'sort_by' && params.has('sort_by')) return;
      params.append(key, value);
    });

    var url = facetForm.getAttribute('action').split('?')[0];
    var query = params.toString();
    window.location.href = query ? url + '?' + query : url;
  }
})();
